import apiService from "./apiService";
import AppConstants from "../appConstants";

class ContentService {
    getAllContent(params) {
        return new Promise((resolve, reject) => {
            apiService.get(AppConstants.URL_CONTENT, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    getContentDetails(id, params) {
        return new Promise((resolve, reject) => {
            apiService.get(`${AppConstants.URL_CONTENT}/${id}`, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    registerContent(form, params) {
        return new Promise((resolve, reject) => {
            apiService.post(AppConstants.URL_CONTENT, form, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    deleteContent(id, params) {
        return new Promise((resolve, reject) => {
            apiService.delete(`${AppConstants.URL_CONTENT}/${id}`, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    report(params) {
        return new Promise((resolve, reject) => {
            apiService.downloadPublicFile(AppConstants.URL_CONTENT_REPORT, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    updateApiCache(params) {
        return new Promise((resolve, reject) => {
            apiService.get(AppConstants.URL_CONTENT_API_CACHE, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    
    // =====================================================================
    
}

export default new ContentService();
